import Http from '../Http';

export class TipoSeguimientoService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const params = new URLSearchParams();
    params.set('p', page.toString());
    params.set('l', limit.toString());
    
    if (Object.keys(filters).length) {
      params.set('q', JSON.stringify(filters));
    }
    if (orderBy) {
      params.set('orderBy', orderBy);
      params.set('order', order);
    }

    try {
      const res = await Http.get(`tipo-seguimiento/filter?${params.toString()}`);
      return res.data.rows || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  static async eliminar(row: any) {
    try {
      const res = await Http.post(`tipo-seguimiento/delete`, row);
      return !res.error;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  static async obtenerPorId(id: string | number) {
    try {
      const res = await Http.get(`tipo-seguimiento/one/${id}`);
      return res.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async guardar(data: any) {
    try {
      const res = await Http.post(`tipo-seguimiento/save`, data);
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: 'Error al guardar Tipo de Seguimiento' };
    }
  }
}
